import React from 'react';
import * as S from './FooterTabs.styled';
export const FooterTabs = ({ tabs, activeTab, onTabChange }) => {
    return (React.createElement(S.Container, null, tabs.map((tab) => (React.createElement(S.Tab, { key: tab, active: tab === activeTab, onClick: () => onTabChange(tab) }, tab)))));
};
